import { FormProvider } from 'react-hook-form'
import React from 'react'
import * as yup from 'yup'
import { MobileSettings } from '@matech/thebigpos-sdk'
import { clsx } from 'clsx'
import { useIntl } from 'react-intl'
import { TextField } from '../../formControls'
import useForm from '../../../hooks/useForm'
import FormRow from '../../formControls/FormRow'
import { Button } from '../../Button'
import Switch from '../../formControls/Switch'

export type MobileSettingsFormFieldValues = Omit<MobileSettings, 'id'>

export type MobileSettingsFormProps = {
	initialValues?: MobileSettingsFormFieldValues
	disabled: boolean
	onSubmit?: (data: MobileSettingsFormFieldValues) => void
}

const schema = yup.object().shape({
	hasMobile: yup.boolean(),
	downloadLink: yup
		.string()
		.url('Must be a valid URL')
		.required('Download link is required'),
})

const defaultValues: MobileSettingsFormFieldValues = {
	hasMobile: false,
	downloadLink: '',
}

const MobileSettingsForm = ({
	initialValues,
	disabled,
	onSubmit,
}: MobileSettingsFormProps) => {
	const methods = useForm<MobileSettingsFormFieldValues>({
		defaultValues: initialValues ?? defaultValues,
		values: initialValues ?? defaultValues,
		schema,
	})

	const { handleSubmit } = methods

	const handleFormSubmit = (data: MobileSettingsFormFieldValues) => {
		onSubmit?.(data)
	}

	const handleSubmitClick = () => {
		handleSubmit(handleFormSubmit)()
	}

	const hasMobile = methods.watch('hasMobile')
	const { formatMessage } = useIntl()

	return (
		<FormProvider {...methods}>
			<FormRow>
				<Switch
					name="hasMobile"
					label={formatMessage({
						id: 'mobile_settings.has_mobile_switch',
					})}
					defaultChecked={false}
					disabled={disabled}
				/>
				<TextField
					name="downloadLink"
					label={formatMessage({
						id: 'mobile_settings.mobile_app_url_label',
					})}
					placeholder={formatMessage({
						id: 'mobile_settings.mobile_app_url_placeholder',
					})}
					fullWidth
					disabled={disabled}
					className={clsx(!hasMobile && '!hidden')}
				/>
			</FormRow>
			{!disabled && (
				<Button text="Submit" onClick={handleSubmitClick} />
			)}
		</FormProvider>
	)
}
export default MobileSettingsForm
